<nav class="navbar navbar-default">
    <div class="navbar-header">
        <div class="navbar-brand">
            <a
                [ngClass]="{'header-minimized': currentBreakPoint <= BreakpointValues.MEDIUM}"
                data-qa="qa-top-navbar-text">{{ 'APP_TITLE' | translate }}</a>
        </div>
    </div>
    <div class="collapse navbar-collapse">
        <ul class="nav navbar-nav nav-tabs first-level">
            <li class="active">
                <a class="nav-item fl-menu-item no-children px-2">{{ menuItem.text | translate }}</a>
            </li>
        </ul>
        <ul class="nav navbar-nav nav-tabs navbar-right first-level context-selector">
            <li>
                @if (showFeedbackButton) {
                    <button
                        [ngClass]="{'feedback-cropped': currentBreakPoint < BreakpointValues.LARGE && scaleAmount <= 1.2}"
                        class="navbar-button interactable feedback" (click)="enableCsatSection()">
                        <div
                            class="vismaicon vismaicon-sm vismaicon-menu navbar-button feedback icon">
                            <img src="/assets/images/icons/16_Paperplane 1.svg" alt="">
                        </div>
                        @if (currentBreakPoint >= BreakpointValues.LARGE && scaleAmount <= 1.2) {
                            <div
                                class="my-auto px-2">{{ 'GIVE_FEEDBACK' | translate }}
                            </div>
                        }
                    </button>
                }
            </li>
            @if (zoomButtonFeatureEnabled | async) {
                <li
                    appCustomPopover
                    placement="bottom"
                    popoverText="ZOOM_HINT"
                    class="navbar-container mx-2 d-flex">
                    <div class="navbar-button d-flex px-2">
                        @if (currentBreakPoint >= BreakpointValues.LARGE && scaleAmount <= 1.2) {
                            <span class="my-auto mr-1">Zoom</span>
                        }
                        <span class="my-auto">{{ zoomAmount }}%</span>
                    </div>
                    <button class="navbar-button zoom interactable out" (click)="zoomOut()">
                        <div class="my-auto mx-auto">&minus;</div>
                    </button>
                    <button class="navbar-button zoom interactable in" (click)="zoomIn()">
                        <div class="my-auto mx-auto">&plus;</div>
                    </button>
                </li>
            }
            <li>
                <a (contextmenu)="onPlanNameRightClick($event)" class="plan-name px-1">{{ planName }}</a>
            </li>
            <li
                class="dropdown user-dropdown icon"
                [ngClass]="{ open: contextVisible }"
                (appClickOutside)="closeContext()"
            >
                <a class="dropdown-toggle button-context" (click)="toggleContext()">
                    <span class="vismaicon vismaicon-menu vismaicon-user"></span>
                    <span class="caret"></span>
                </a>
                <ul class="dropdown-menu company-selection py-0" role="menu">
                    <li class="py-1 my-1" role="menuitem">
                        <a class="pl-4" (click)="changeLanguage(languages.English)">English</a>
                        <a class="pl-4" (click)="changeLanguage(languages.Norwegian)">Norwegian</a>
                    </li>
                    @if ((licenseAttributionFeatureEnabled | async) ) {
                        <div id="dropdown-nav-options">
                            @if (licenseAttributionFeatureEnabled | async) {
                                <a
                                    (click)="openAttributionModal()" class="pl-4 py-2 dropdown-nav-option">
                                    {{ "LICENSE_ATTRIBUTION" | translate }}
                                </a>
                            }
                        </div>
                    }
                </ul>
            </li>
        </ul>
    </div>
</nav>
